export default __webpack_public_path__ + "static/media/landing.57558534.jpg";